var map = {
	"./_settings.scss": 1411,
	"./base/_alert-boxes.scss": 1412,
	"./base/_badges.scss": 1413,
	"./base/_base.scss": 1414,
	"./base/_cw-footer.scss": 1415,
	"./base/_fonts.scss": 1416,
	"./base/_forms.scss": 1417,
	"./base/_grid.scss": 1418,
	"./base/_layout.scss": 1419,
	"./base/_lightbox.scss": 1420,
	"./base/_modal.scss": 1421,
	"./base/_nav-bar.scss": 1422,
	"./base/_normal_font.scss": 117,
	"./base/_offcanvas.scss": 1423,
	"./base/_pagination.scss": 1424,
	"./base/_panels.scss": 1425,
	"./base/_sharing.scss": 1426,
	"./base/_switches.scss": 1427,
	"./base/_tables.scss": 1428,
	"./base/_tooltips.scss": 1429,
	"./base/_type.scss": 1430,
	"./base/_video.scss": 1431,
	"./base/_visibility.scss": 1432,
	"./base/buttons/_all.scss": 1433,
	"./base/buttons/_mixins.scss": 1434,
	"./base/buttons/_sharing.scss": 1435,
	"./base/forms/_checkboxes.scss": 1436,
	"./base/forms/_input-combos.scss": 1437,
	"./base/forms/_non-text.scss": 1438,
	"./base/forms/_text-fields.scss": 1439,
	"./base/nav-bar/_base-with-links.scss": 1440,
	"./base/nav-bar/_base.scss": 1441,
	"./base/nav-bar/_fade.scss": 1442,
	"./base/nav-bar/_inverted.scss": 1443,
	"./base/nav-bar/_large-up.scss": 1444,
	"./components/_hero.scss": 1445,
	"./pages/accounts.scss": 1446,
	"./pages/admin.scss": 1447,
	"./pages/admin/grants.scss": 1448,
	"./pages/admin/offline_donations.scss": 1449,
	"./pages/asset_generator.scss": 1450,
	"./pages/authorization.scss": 1451,
	"./pages/birthdays.scss": 1452,
	"./pages/campaigns.scss": 1453,
	"./pages/donations.scss": 1454,
	"./pages/donations/_donate-form.scss": 1455,
	"./pages/donations/_hidden-campaign.scss": 1456,
	"./pages/donations/_sponsor-recognition.scss": 1457,
	"./pages/donations/_thank-you.scss": 1458,
	"./pages/donations/components/_ach-popout-form.scss": 1459,
	"./pages/donations/components/_apple-pay-button.scss": 1460,
	"./pages/donations/components/_browser-fallback.scss": 1461,
	"./pages/donations/components/_donate-buttons.scss": 1462,
	"./pages/donations/components/_donate-by-check-modal.scss": 1463,
	"./pages/donations/components/_donation-form-inputs.scss": 1464,
	"./pages/donations/components/_gift_aid.scss": 1465,
	"./pages/donations/components/_iho.scss": 1466,
	"./pages/donations/components/_offscreen-donate-components.scss": 1467,
	"./pages/donations/components/_stripe-elements.scss": 1468,
	"./pages/donations/dynamic.scss": 1469,
	"./pages/donations/general.scss": 1470,
	"./pages/donations/gift-the-spring.scss": 1471,
	"./pages/donations/in-honor-of.scss": 1472,
	"./pages/donations/sponsor.scss": 1473,
	"./pages/donations/the-spring-new.scss": 1474,
	"./pages/donations/thespring.scss": 1475,
	"./pages/edit_mailing_list_subscriber.scss": 1476,
	"./pages/exceptions.scss": 1477,
	"./pages/founders.scss": 1478,
	"./pages/mailing-list-subscribers.scss": 1479,
	"./pages/partners.scss": 1480,
	"./pages/premium_impact_profile.scss": 1481,
	"./pages/profile/bps_membership.scss": 1482,
	"./pages/profile/lifetime_impact.scss": 1483,
	"./pages/profile/my_projects.scss": 1484,
	"./pages/profile/shared.scss": 1485,
	"./pages/profile/spring_membership.scss": 1486,
	"./pages/profile/user_private.scss": 1487,
	"./pages/profile/user_public.scss": 1488,
	"./pages/projects/_country_icons.scss": 1489,
	"./pages/projects/projects.scss": 1490,
	"./pages/redeem-the-spring.scss": 1491,
	"./pages/search.scss": 1492,
	"./pages/september-campaign/_modal.scss": 1493,
	"./pages/september_2020.scss": 1494,
	"./pages/static_pages/about.scss": 1495,
	"./pages/static_pages/brand_partnerships.scss": 1496,
	"./pages/static_pages/company_match.scss": 1497,
	"./pages/static_pages/company_match_iframe.scss": 1498,
	"./pages/static_pages/completed_projects.scss": 1499,
	"./pages/static_pages/css_docs.scss": 1500,
	"./pages/static_pages/education.scss": 1501,
	"./pages/static_pages/error.scss": 1502,
	"./pages/static_pages/financials.scss": 1503,
	"./pages/static_pages/fundraise.scss": 1504,
	"./pages/static_pages/gala_dashboard.scss": 1505,
	"./pages/static_pages/get_involved.scss": 1506,
	"./pages/static_pages/home.scss": 1507,
	"./pages/static_pages/hundred_percent_model.scss": 1508,
	"./pages/static_pages/in_kind_donations.scss": 1509,
	"./pages/static_pages/internships.scss": 1510,
	"./pages/static_pages/jobs.scss": 1511,
	"./pages/static_pages/kids.scss": 1512,
	"./pages/static_pages/local_partners.scss": 1513,
	"./pages/static_pages/media.scss": 1514,
	"./pages/static_pages/mission.scss": 1515,
	"./pages/static_pages/our_approach.scss": 1516,
	"./pages/static_pages/our_projects.scss": 1517,
	"./pages/static_pages/our_work.scss": 1518,
	"./pages/static_pages/privacy.scss": 1519,
	"./pages/static_pages/scott_harrison_story.scss": 1520,
	"./pages/static_pages/scotts_story.scss": 1521,
	"./pages/static_pages/sensors.scss": 1522,
	"./pages/static_pages/staff.scss": 1523,
	"./pages/static_pages/the_pool.scss": 1524,
	"./pages/static_pages/volunteer.scss": 1525,
	"./pages/static_pages/water_crisis_learn.scss": 1526,
	"./pages/static_pages/whywater.scss": 1527,
	"./pages/stories.scss": 1528,
	"./pages/subscriptions.scss": 1529,
	"./pages/the_spring_series.scss": 1530,
	"./pages/thirst/thirst.scss": 1531,
	"./pages/tributary.scss": 1532,
	"./pages/uk/about.scss": 1533,
	"./pages/uk/partnerships.scss": 1534,
	"./pages/uk/privacy.scss": 1535,
	"./pages/uk/uk.scss": 1536,
	"./pages/unpledge.scss": 1537,
	"./pages/video_landing_page.scss": 1538,
	"./pages/wwd/community.scss": 1539,
	"./pages/wwd/discover.scss": 1540,
	"./pages/wwd/explore.scss": 1541,
	"./pages/wwd/profile.scss": 1542,
	"./pages/wwd/shared.scss": 1543,
	"./pages/wwd/welcome.scss": 1544,
	"./patterns/action-tiles.scss": 1545,
	"./patterns/avatar-initial.scss": 1546,
	"./patterns/cards.scss": 1547,
	"./patterns/clamp-for-ellipsis.scss": 1548,
	"./patterns/cw-icon-spin.scss": 1549,
	"./patterns/dashed-elements.scss": 1550,
	"./patterns/full-bottom-bg.scss": 1551,
	"./patterns/image-fill.scss": 1552,
	"./patterns/latest-update-indicator.scss": 1553,
	"./patterns/leading-image-block.scss": 1554,
	"./patterns/module.scss": 1555,
	"./patterns/progress.scss": 1556,
	"./patterns/side-by-side.scss": 1557,
	"./patterns/split-bg-block.scss": 1558,
	"./patterns/tabs.scss": 1559,
	"./patterns/text-separator.scss": 1560,
	"./patterns/yellow-underlined.scss": 1561,
	"./react-components/completed-projects-map.scss": 1562,
	"./react-components/email-capture-modal.scss": 1563,
	"./react-components/journey-player.scss": 1564,
	"./react-components/mailing-list-intercept-modal.scss": 1565,
	"./react-components/people-served-input.scss": 1566,
	"./settings/_colors.scss": 1567,
	"./settings/_general.scss": 1568,
	"./settings/_media-queries.scss": 1569,
	"./settings/_mixins.scss": 1570,
	"./settings/_type.scss": 1571,
	"./shared/breadcrumbs.scss": 1572,
	"./shared/clipboard-button.scss": 1573,
	"./shared/comments.scss": 1574,
	"./shared/cookie_banner.scss": 1575,
	"./shared/datepicker.scss": 1576,
	"./shared/fixed-banner.scss": 1577,
	"./shared/geosuggest.scss": 1578,
	"./shared/grecaptcha.scss": 1579,
	"./shared/hide-donate-links.scss": 1580,
	"./shared/intl-tel-input.scss": 1581,
	"./shared/mailing-list-form.scss": 1582,
	"./shared/mailing-list-sign-up-button.scss": 1583,
	"./shared/mobile-donate-banner.scss": 1584,
	"./shared/parsley.scss": 1585,
	"./shared/percy.scss": 1586,
	"./shared/public_campaign_card_details.scss": 1587,
	"./shared/simple-form.scss": 1588,
	"./shared/sly-quiz.scss": 1589,
	"./shared/spring_logo_svg.scss": 1590,
	"./shared/spring_mark_svg.scss": 1591,
	"./shared/spring_series_seasons.scss": 1592,
	"./shared/video-box-container.scss": 1593,
	"./tailwinds.scss": 251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1410;